module.exports = __webpack_public_path__ + "img/flash-dashboard.de63ed43.svg";